export enum InsuranceTypeEnum {
  Ac = 'AC',
  AcMini = 'AC_MINI',
  Assistance = 'ASSISTANCE',
  Glass = 'GLASS',
  Nnw = 'NNW',
  Oc = 'OC',
}
